import { Button } from '@uhg-abyss/web/ui/Button';
import { Link } from '@uhg-abyss/web/ui/Link';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Markdown } from '../../Markdown';
import { StyledFontSizeModal } from './FontSizeModal.style';

interface FontSizeModalProps {
  linkColor?: string;
  textColor?: string;
  buttonBgColor?: string;
}

export const FontSizeModal: React.FC<FontSizeModalProps> = ({
  linkColor = '#196ECF',
  textColor = '#323333',
  buttonBgColor = '#002677',
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const linkRef = useRef<HTMLAnchorElement>(null);

  const handleClose = () => {
    setIsOpen(false);

    // Focus back on the link after closing the modal
    setTimeout(() => {
      linkRef.current?.focus();
    }, 0);
  };
  const { t } = useTranslation();

  const footer = (
    <Button
      css={{
        backgroundColor: `${buttonBgColor} !important`,
        '&:hover': {
          backgroundColor: `${buttonBgColor} !important`,
          opacity: 0.9,
        },
      }}
      data-testid="font-size-modal-close-button"
      onClick={handleClose}
    >
      {t('FONT_SIZE_CONTENT.CloseButton')}
    </Button>
  );

  return (
    <>
      <Link
        css={{
          fontSize: '$sm',
          color: linkColor,
          textDecoration: 'none',
          cursor: 'pointer',
        }}
        data-testid="font-size-link"
        onClick={() => {
          setIsOpen(true);
        }}
        ref={linkRef}
      >
        {t('FONT_SIZE')}
      </Link>
      {isOpen && (
        <StyledFontSizeModal
          closeOnClickOutside={false}
          css={{
            '.abyss-modal-base-body': {
              color: textColor,
            },
            '.abyss-modal-base-header': {
              color: textColor,
            },
          }}
          data-testid="font-size-modal"
          footer={footer}
          header={t('FONT_SIZE_CONTENT.Title')}
          isOpen={isOpen}
          onClose={handleClose}
          size="$sm"
        >
          <Markdown>{t('FONT_SIZE_CONTENT.Content')}</Markdown>{' '}
        </StyledFontSizeModal>
      )}
    </>
  );
};

export default FontSizeModal;
